
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'marketplace-storefront-public-ui',
  currentProjectVersion: 'static-1.12145',
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.12145",
  "apollo-dlb": "static-3.86",
  "client-types": "static-1.465",
  "dashboard-client-types": "static-1.361",
  "data-fetching-client": "static-1.9640",
  "foundations-components": "static-1.7867",
  "foundations-components-legacy": "static-1.892",
  "foundations-theming": "static-1.4386",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.81",
  "head-dlb": "static-1.4938",
  "hs-test-utils": "static-1.7982",
  "hub-http-shared-msw-handlers": "static-1.9885",
  "hubspot-dlb": "static-2.1832",
  "hubspot-url-utils": "static-1.4049",
  "HubStyleTokens": "static-2.11433",
  "I18n": "static-7.1615",
  "jasmine-runner": "static-1.6435",
  "marketplace-storefront-base": "static-1.12206",
  "quartz": "static-1.6982",
  "react-dlb": "static-1.78",
  "react-rhumb": "static-1-feature-id-1459-enable-web-vitals-adapter.5",
  "reactive-variable-buffer-atom": "static-1.2827",
  "reporting-testing-lib": "static-1-jbartola_hubspot-replace-checked-ts.72",
  "settings-ui-lib": "static-1.12489",
  "SharedI18nStrings": "static-1.182",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.7074",
  "ui-addon-i18n": "static-1.11118",
  "ui-addon-react-router-dom": "static-1.9512",
  "unified-auth": "static-1.451",
  "unified-auth-core-lib": "static-1.732",
  "usage-tracker": "static-1.7314",
  "usage-tracker-core": "static-1.7164",
  "customer-data-property-utils": "static-1.8054",
  "hub-http": "static-1.6190",
  "integrations-lib": "static-1.16014",
  "marketplace-ui-common": "static-1.19601",
  "property-management-iframe": "static-1.13036",
  "quartz-config": "static-1.760",
  "quartz-core": "static-1.6201",
  "quartz-routing": "static-1.412",
  "quick-fetch": "static-1.3889",
  "react": "static-7.185",
  "rpc-client-utils": "static-1.4619",
  "ts-schema": "static-1.4050",
  "ui-universal-auth": "static-1.8937",
  "UIComponents": "static-3.8380",
  "apollo-stack-hubspot": "static-3.84",
  "enviro": "static-4.428",
  "hs-promise-rejection-tracking": "static-1.5489",
  "PortalIdParser": "static-2.388",
  "raven": "static-3.5829",
  "raven-hubspot": "static-1.6136",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.77",
  "metrics-js": "static-1.9542",
  "react-redux": "static-7.70",
  "redux": "static-4.16",
  "styled-components": "static-2.88",
  "bend-plugin-trellis-migration": "static-1.3376",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3259",
  "quartz-webpack": "static-1.3206",
  "bend-plugin-quartz-routing": "static-1.60",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.4136",
  "floating-ui": "static-1.55",
  "foundations-assets": "static-1.4830",
  "foundations-theming-specialty": "static-1.2102",
  "framer-motion": "static-1.71",
  "hs-story-utils": "static-1.9397",
  "react-aria": "static-1.65",
  "react-create-root-preference": "static-1.13",
  "react-select-plus": "static-1.104",
  "react-utils": "static-2.5316",
  "react-virtualized": "static-2.98",
  "StyleGuideUI": "static-3.486",
  "tanstack-table": "static-1.54",
  "trellis-assets": "static-1.1766",
  "ui-fonts": "static-1.695",
  "ui-images": "static-2.1143",
  "bend-plugin-foundations-theming": "static-1.2869",
  "foundations-theming-base": "static-1.3371",
  "stylex": "static-1.32",
  "HeadJS": "static-2.745",
  "hs-test-utils-bend-plugin": "static-1.3093",
  "msw": "static-1.39",
  "testing-library": "static-1.151",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.220",
  "moment-timezone": "static-5.82",
  "jasmine": "static-4.4295",
  "ai-components-ui-library": "static-1.8857",
  "ai-rendering-library": "static-1.10011",
  "chirp-fetch": "static-1.1855",
  "connections-embed-lib": "static-1.930",
  "copilot-toolkit": "static-1.11051",
  "feedback-loader": "static-1.29237",
  "laboratory-lib": "static-3.7128",
  "marketplace-embed": "static-1.21986",
  "marketplace-ui-details": "static-1.9497",
  "marketplace-ui-reviews": "static-1.19557",
  "marketplace-ui-tracking": "static-1.13772",
  "sanitize-text": "static-1.8111",
  "ui-addon-video-player": "static-1.8669",
  "usage-tracker-multi": "static-1.5728",
  "usage-tracker-session-replay": "static-1.5000",
  "wootric-nps": "static-1.6951",
  "quartz-head": "static-1.647",
  "web-vitals": "static-1.4",
  "apollo-link-hub-http": "static-2.4617",
  "immer": "static-1.33",
  "immerable": "static-1.4123",
  "highcharts": "static-8.103",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2485",
  "reporting-data": "static-1-jbartola_hubspot-replace-checked-ts.72",
  "cssUtils": "static-1.782",
  "flux-actions": "static-1.331",
  "HubStyle": "static-2.11741",
  "PatternValidationJS": "static-1.437",
  "react-colorpicker": "static-2.10178",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10339",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7304",
  "icons": "static-2.644",
  "marketplace-ui-apps-core": "static-1.18134",
  "storybook-react": "static-1.32",
  "trellis-story-utils": "static-1.4484",
  "foundations-components-test-utils": "static-1.5350",
  "quartz-i18n": "static-1.657",
  "react-input-autosize": "static-2.17",
  "google-sheets-integration-lib": "static-1.141",
  "microsoft-drive-integration-lib": "static-1.258",
  "fsm": "static-1.3700",
  "customer-data-objects": "static-1.7631",
  "property-translator": "static-1.5370",
  "hs-locale-management": "static-1.58",
  "frontend-preferences-client": "static-1.7897",
  "hs-promise-utils": "static-1.5563",
  "hubspot-apollo-client": "static-1.4845",
  "integrations-error-boundary-lib": "static-1.13429",
  "integrations-tracking-lib": "static-1.5568",
  "native-integrations-shared-strings": "static-1.7751",
  "reselect": "static-2.16",
  "sanitize": "static-1.4444",
  "superstore": "static-1.4734",
  "ui-shepherd-react": "static-3.10123",
  "ai-settings-ui-library": "static-1.7832",
  "hub-http-janus": "static-1.828",
  "hubspotter-http": "static-1.4624",
  "immutable-less": "static-1.4620",
  "marketplace-ui-client-types": "static-1.17008",
  "nav-meta": "static-1.29569",
  "react-window": "static-1.13",
  "self-service-api": "static-1.10214",
  "ui-addon-upgrades": "static-9.17937",
  "inbound-db-properties-service-client": "static-1.3816",
  "property-management-common": "static-1.5324",
  "ui-addon-iframeable": "static-1.9026",
  "dispatcher": "static-1.135",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.519",
  "module-federation": "static-1.22",
  "quartz-auth": "static-1.657",
  "quartz-test": "static-1.657",
  "quartz-tracking": "static-1.361",
  "history": "static-4.47",
  "react-router-dom": "static-5.26",
  "csstype": "static-1.50",
  "bend-plugin-chirp-manifest": "static-1.29",
  "bender-build-tools": "static-1.3160",
  "inbound-db-meta-service-client": "static-1.3563",
  "persist-promise": "static-1.3668",
  "reference-resolvers": "static-1.8137",
  "transmute": "static-2.85",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.21139",
  "ContentUtils": "static-1.68266",
  "customer-data-objects-ui-components": "static-1.12994",
  "sassPrefix": "static-1.155",
  "avatar-components": "static-1.2466",
  "customer-data-filters-ui": "static-1.39641",
  "customer-data-reference-ui-components": "static-1.13128",
  "embedded-academy-lib": "static-1.14240",
  "ExportDialog": "static-6.10362",
  "highlight.js": "static-1.78",
  "markdown-it": "static-1.6",
  "reporting-action-components": "static-1.41211",
  "reporting-snowflake": "static-1-jbartola_hubspot-replace-checked-ts.72",
  "reporting-ui-components": "static-2-jbartola_hubspot-replace-checked-ts.72",
  "reporting-visualizations": "static-1-jbartola_hubspot-replace-checked-ts.72",
  "ui-addon-teams": "static-1.21501",
  "magpie-lib": "static-1.5536",
  "navigation-components": "static-1.17932",
  "magpie-types": "static-1.4996",
  "simple-logging-lib": "static-1.3018",
  "ai-studio-lib": "static-1.11515",
  "app-governance-lib": "static-1.1444",
  "developer-experience-shared-components": "static-1.10478",
  "ui-addon-integrations-directory-panel": "static-2.7965",
  "ui-product-approvals": "static-1.28046",
  "ui-tool-access": "static-1.10119",
  "usage-based-billing-components-lib": "static-1.8718",
  "usage-tracker-anonymous": "static-1.5731",
  "usage-tracker-public": "static-1.7125",
  "amplitude-session-replay-browser": "static-1.59",
  "ui-extensibility-client-types": "static-1.3897",
  "hubspot-apollo-cache": "static-1.304",
  "universal-page-editor-lib": "static-1.2982",
  "final-form": "static-1.69",
  "redux-toolkit": "static-1.7",
  "simple-data-table": "static-1.2686",
  "merchandise-lib": "static-1.262",
  "atom": "static-1.5040",
  "purchase-motions-components": "static-1.5823",
  "salesImages": "static-1.524",
  "batch-promise": "static-1.1511",
  "crm-component-utils": "static-1.38998",
  "crm-properties-common-lib": "static-1.5847",
  "customer-data-properties": "static-1.51432",
  "framework-data-schema-resolvers": "static-1.6850",
  "property-value-citations": "static-1.2046",
  "reference-resolvers-lite": "static-1.8064",
  "navigation-messaging": "static-1.7259",
  "hubspotter-http-shared-msw-handlers": "static-1.9883",
  "growth-payments-core": "static-1.25281",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.13587",
  "conversations-skeleton-state": "static-1.7217",
  "crm-message-bus": "static-1.42905",
  "reporting-plugins": "static-1.10268",
  "reporting-reports": "static-1-jbartola_hubspot-replace-checked-ts.72",
  "cms-field-types": "static-1.4781",
  "content-icons-ui": "static-1.2216",
  "customer-data-ui-utilities": "static-1.9794",
  "customer-data-filters-ui-msw-helpers": "static-1.22076",
  "FormUrlGenerator": "static-2.4687",
  "framework-builder-read-service-client": "static-1.3982",
  "framework-data-schema-quick-fetch": "static-1.6755",
  "multi-account-reference-resolvers": "static-1.947",
  "onboarding-tours": "static-1.16536",
  "academy-common-lib": "static-1.13700",
  "content-assistance-lib": "static-1.7700",
  "dashboard-lib": "static-1.81388",
  "file-manager-components": "static-1.23527",
  "getting-started-shared-tasks": "static-1.18414",
  "hubspot-prosemirror": "static-1.18154",
  "hubspot-prosemirror-plugins": "static-1.18146",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.19773",
  "share-with-third-party-component-lib": "static-1.8670",
  "ui-addon-draggable": "static-3.4737",
  "ui-asset-management-lib": "static-1.10979",
  "ui-business-units-lib": "static-1.9018",
  "user-context": "static-1.5071",
  "idb-keyval": "static-1.43",
  "reactive-lib": "static-1.690",
  "nest": "static-1.194",
  "codemirror": "static-5.94",
  "react-codemirror": "static-1.10593",
  "framework-listing-lib": "static-2.28600",
  "fuzzy": "static-1.8",
  "user-configuration-lib": "static-1.30644",
  "apps-service-types": "static-1.3846",
  "oauth-service-types": "static-1.4219",
  "onboarding-scopes": "static-1.6431",
  "onboarding-tours-client": "static-1.4750",
  "platform-infra-nav-components": "static-1.7645",
  "subscription-experience-data-types": "static-1.14883",
  "crm-record-cards-service-types": "static-1.3581",
  "location-customization-utils-lib": "static-1.9156",
  "redux-thunk": "static-2.43",
  "purchase-motions-api": "static-1.5826",
  "signup-constants": "static-1.18784",
  "signup-ui-url-generator": "static-2.8009",
  "trials-service-types": "static-1.3872",
  "card-properties-lib": "static-1.44081",
  "commerce-subscription-lib": "static-1.37013",
  "crm-actions": "static-1.6290",
  "crm-cards-sdk": "static-1.43490",
  "customer-data-properties-shared-msw-handlers": "static-1.9212",
  "customer-data-tracking": "static-1.6854",
  "hs-resources": "static-1.120",
  "pulse": "static-1.533",
  "calling-global-api": "static-1.64406",
  "calling-internal-common": "static-1.31271",
  "calling-lifecycle-internal": "static-1.65788",
  "calling-lifecycle-messages": "static-1.58082",
  "commerce-products-lib": "static-1.9431",
  "conditional-properties-service-client": "static-1.3769",
  "crm-links": "static-1.6253",
  "external-options-client-types": "static-1.4130",
  "google-libphonenumber": "static-1.37",
  "inbounddb-objects-service-types": "static-1.4196",
  "meetings-icalendar-utils-lib": "static-1.601",
  "multi-currency-client-types": "static-1.3664",
  "object-builder-ui-client": "static-1.48629",
  "pipeline-validation-client-types": "static-1.3938",
  "smart-property-lib": "static-1.6757",
  "tiered-pricing": "static-1.1132",
  "ui-addon-form-validation": "static-1.10959",
  "crm-pipelines-api-client-types": "static-1.4115",
  "ui-addon-opt": "static-4.8338",
  "campaign-roi-lib": "static-1.8997",
  "react-dnd-compat": "static-1.4589",
  "react-immutable-render-mixin": "static-1.9",
  "growth-data-modal": "static-1.5376",
  "growth-onboarding-confetti": "static-1.3035",
  "growth-onboarding-next-action-utils": "static-1.1829",
  "onboarding-tours-utils": "static-1.602",
  "ui-shepherd-tracker": "static-1.7504",
  "academy-service-client": "static-1.3650",
  "croppie": "static-2.10",
  "FileManagerCore": "static-1.39026",
  "FileManagerLib": "static-1.39167",
  "video-embed": "static-1.35659",
  "zustand": "static-1.74",
  "ui-coaching-tips": "static-1.28460",
  "redux-actions": "static-3.7",
  "video-components-external": "static-1.11167",
  "video-data-lib": "static-1.34825",
  "emoji-mart": "static-3.4",
  "knowledge-content-types": "static-1.8483",
  "payment-link-components": "static-1.23446",
  "ui-addon-emoji-picker": "static-1.9856",
  "EmailSignatureEditor": "static-1.24298",
  "viral-links-lib": "static-1.7025",
  "data-token-picker": "static-1.16347",
  "react-flip-move": "static-1.69",
  "nested-table": "static-1.193",
  "timezone-utils": "static-2.5212",
  "getting-started-shared-tasks-store": "static-1.17532",
  "diff-match-patch": "static-1.7",
  "browser-eslint": "static-2.57",
  "customer-data-associations": "static-1.7293",
  "customer-data-views-management": "static-1.25384",
  "framework-data-table": "static-2.11840",
  "marketing-platform-lib": "static-1.6821",
  "nudge-client-utils": "static-1.2497",
  "nudge-custom-ui-functions": "static-1.975",
  "app-users-service-client": "static-1.5564",
  "app-users-service-types": "static-1.4972",
  "mini-checkout-client": "static-1.26717",
  "onboarding-utils": "static-1.5322",
  "permissions-shared-i18n-strings-fe": "static-1.2044",
  "ui-coaching-tips-shared-config": "static-1.28445",
  "edison-service-client-types": "static-1.355",
  "crm_data": "static-4.91859",
  "customer-data-sidebar": "static-2.45921",
  "enrichment-properties-lib": "static-1.15875",
  "commerce-billing-lib": "static-1.18974",
  "commerce-shared-components-lib": "static-1.18439",
  "commerce-tools-ui-lib": "static-1.10284",
  "crm-fe-perf": "static-1.22872",
  "bend-plugin-pulse": "static-1.36",
  "directed-graph": "static-1.904",
  "event-emitter": "static-1.917",
  "fast-json-patch": "static-1.62",
  "calling-error-reporting": "static-1.31277",
  "shared-worker-versioning": "static-1.11007",
  "calling-usage-tracker": "static-1.6512",
  "voice-sms-access-library": "static-1.852",
  "commerce-permissions": "static-1.735",
  "products-iframe-lib": "static-1.7843",
  "products-ui-components-shared-msw-handlers": "static-1.10267",
  "data-agent-kit": "static-1.141",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9968",
  "policy-lib": "static-1.6744",
  "react-tinymce": "static-1.55147",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10031",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.54273",
  "tinymce-plugins": "static-1.57387",
  "tinymce-themes": "static-1.56243",
  "breeze-engine-lib": "static-1.504",
  "onboarding-data-sync-lib": "static-1.1905",
  "growth-onboarding-next-action-components": "static-1.1857",
  "user-context-client": "static-1.4580",
  "audio-components": "static-1.5865",
  "cropperjs": "static-1.10",
  "FileManagerImages": "static-1.36678",
  "urlinator": "static-1.4501",
  "video-components": "static-1.13170",
  "outpost": "static-1.4155",
  "growth-onboarding-feedback-components": "static-1.6550",
  "content-media-composition-data-lib": "static-1.12152",
  "content-media-compositions": "static-2.16159",
  "media-bridge-lib": "static-1.18870",
  "commerce-tours-lib": "static-1.6032",
  "growth-onboarding-reliability": "static-1.5051",
  "sales-checkout-service-client": "static-1.3608",
  "draft-convert": "static-2.72",
  "draft-extend": "static-3.74",
  "draft-js": "static-5.77",
  "draft-plugins": "static-2.21616",
  "sales-email-signature-service-client": "static-1.3811",
  "ts-utils-lib": "static-1.142",
  "crm-export-dialog": "static-1.6267",
  "crm-index-associations-lib": "static-1.6409",
  "react-beautiful-dnd": "static-1.13",
  "deal-intel-decorators": "static-1.1878",
  "tanstack-virtual": "static-1.29",
  "nudge-custom-function-registry": "static-1.2254",
  "nudge-renderer-utils": "static-1.2573",
  "whisper-core-api": "static-1.6529",
  "InboxConnectUtils": "static-4.14724",
  "emoji-regex": "static-1.7",
  "touchless-buying-components": "static-1.5424",
  "settings-content-modals": "static-1.45986",
  "crm_universal": "static-1.21948",
  "customer-data-email": "static-1.17975",
  "card-payment-highlight-lib": "static-1.37073",
  "card-subscription-highlight-lib": "static-1.39436",
  "commerce-contract-lib": "static-1.11925",
  "invoices-highlight-card-lib": "static-1.54615",
  "orders-highlight-card-lib": "static-1.21382",
  "products-highlight-card-lib": "static-1.17715",
  "quotes-highlight-card-lib": "static-1.71894",
  "crm-source-interpretation-lib": "static-1.5307",
  "utility-belt": "static-1.2505",
  "payments-enrollment-embed-lib": "static-1.22661",
  "stripe-embedded-components": "static-1.7445",
  "customer-data-rte": "static-1.32907",
  "cv-backend-services": "static-1.1552",
  "growth-onboarding-empty-states": "static-1.5658",
  "payments-post-enroll-local-storage-lib": "static-1.5078",
  "qrcode-generator": "static-1.68",
  "quotes-client-types": "static-1.37984",
  "calling-orchestration-schema": "static-1.35629",
  "sales-views-client-types": "static-1.4233",
  "hub-http-contrib": "static-1.3007",
  "interframe": "static-3.4728",
  "tinymce-data": "static-1.40358",
  "ui-addon-sales-email": "static-1.5179",
  "layout-dnd-components": "static-1.12381",
  "layout-dnd-utils": "static-1.11356",
  "ui-brand-identity-lib": "static-1.15130",
  "NamespacedHubStyle": "static-2.9035",
  "ably": "static-2.2",
  "social-insights-client-types": "static-1.22006",
  "js-cookie": "static-1.18",
  "deal-intel-utils": "static-1.1882",
  "checkout-sdk": "static-3.23560",
  "checkout-service-types": "static-1.3799",
  "company-details-components": "static-1.6165",
  "payment-method-components": "static-1.6881",
  "pricing-pages-ui-components": "static-1.13782",
  "quote-checkout-service-types": "static-1.3443",
  "upgrade-catalog-service-types": "static-1.3493",
  "access-control-lib": "static-1.10405",
  "EmailComponents": "static-1.54685",
  "EmailData": "static-1.53362",
  "redux-less": "static-2.9451",
  "sequences-lib": "static-1.7983",
  "ui-gdpr-components": "static-1.10315",
  "products-ui-components": "static-1.39950",
  "accounting-integrations-ui-components": "static-1.7011",
  "invoices-ui-lib": "static-1.54631",
  "commerce-products-api": "static-1.2237",
  "invoices-iframe-lib": "static-1.56689",
  "quotes-modal-lib": "static-1.102572",
  "quotes-ui-lib": "static-1.80615",
  "stripe-connect-js": "static-1.68",
  "draft-content-plugins": "static-1.28175",
  "ContentData": "static-1.68341",
  "layout-data-lib": "static-1.9681",
  "hub-http-rxjs": "static-1.794",
  "normalizr": "static-3.9",
  "ramda": "static-1.7",
  "company-details-service-types": "static-1.3903",
  "billing-payments-client-types": "static-1.3958",
  "react-performance-metrics-lib": "static-1.528",
  "account-and-billing-fintech-outages": "static-3.18537",
  "pricing-pages-api": "static-1.13647",
  "ContentComponents": "static-2.71222",
  "marketing-contacts-lib": "static-1.9888",
  "marketing-email-service-types": "static-1.1897",
  "messaging-editing-lib": "static-1.46174",
  "messaging-usage-based-billing-components-lib": "static-1.1036",
  "automation-ui-source-apps": "static-1.18782",
  "automation-ui-types": "static-1.19700",
  "messaging-types-lib": "static-1.45911",
  "onboarding-settings-client": "static-1.4472",
  "sequences-client-types-lib": "static-1.7840",
  "commerce-tax-lib": "static-1.493",
  "price-books-api": "static-1.537",
  "price-books-components": "static-1.595",
  "property-description-translator": "static-1.3815",
  "ramp-editor": "static-1.66",
  "commerce-analytics-service-client": "static-1.3596",
  "totals-ui-components": "static-1.23505",
  "SalesContentIndexUI": "static-3.9193",
  "advanced-menus-core": "static-1.15079",
  "advanced-menus-lib": "static-1.12026",
  "ui-memberships-settings-lib": "static-1.33958",
  "segments-query-core": "static-1.1387",
  "demographics-service-types": "static-1.1621",
  "eligibility-engine-service-types": "static-1.3153",
  "automation-ui-ubb": "static-1.5616",
  "blueimp-md5": "static-1.8",
  "content-embed-lib": "static-1.7308",
  "data-token-views": "static-1.16328",
  "forms-utils-lib": "static-1.12516",
  "payments-embed-points-lib": "static-1.12961",
  "simple-menus-core": "static-1.15078",
  "simple-menus-lib": "static-1.16595",
  "ui-addon-draggable-compat": "static-2.4224",
  "videoconference-integration-components": "static-1.6771",
  "marketing-contacts-client": "static-1.7487",
  "automation-applications-service-types": "static-1.3470",
  "automation-platform-service-types": "static-1.2572",
  "ContentEditorUI": "static-2.77024",
  "short-messages-app-service-client": "static-1.3949",
  "web-interactives-components": "static-1.13702",
  "web-interactives-data": "static-1.13703",
  "messaging-shared-utils-lib": "static-1.485",
  "messaging-user-info-utils-lib": "static-1.655",
  "email-portal-health-service-types": "static-1.945",
  "line-items-api": "static-1.638",
  "commerce-totals-service-types": "static-1.3790",
  "FireAlarmUi": "static-1.4486",
  "sales-templates-service-types-lib": "static-1.4141",
  "seamless-immutable": "static-7.6",
  "automation-ui-core": "static-2.21636",
  "automation-ui-usage-tracking": "static-1.21099",
  "data-studio-ubb": "static-1.2631",
  "backbone": "static-1.6",
  "campaigns-lib": "static-1.26946",
  "collaboration-sidebar": "static-1.57703",
  "content-management-data-lib": "static-1.5343",
  "copilot-plugins": "static-1.11024",
  "cta-picker": "static-1.36313",
  "customer-agent-discovery-components-lib": "static-1.2998",
  "editor-components": "static-1.13185",
  "editor-iframe-lib": "static-1.8355",
  "error-messaging-js": "static-1.5160",
  "FormsCommonComponents": "static-1.85751",
  "pictos": "static-7.183",
  "react-transition-group": "static-2.64",
  "redux-request-state": "static-1.10614",
  "SharedLegalStrings": "static-1.1715",
  "smart-content-core": "static-1.42348",
  "smart-content-lib": "static-1.43001",
  "social-composer-lib": "static-1.58966",
  "structured-content-lib": "static-1.25104",
  "theme-previewer-lib": "static-1.53162",
  "tinymce-copilot": "static-1.16341",
  "xray-recommendation-lib": "static-1.7854",
  "automation-ui-routing": "static-1.21057",
  "sql-reporting-client-types": "static-1.5608",
  "jquery": "static-3.6",
  "attribution-lib": "static-1.42122",
  "campaigns-utils-lib": "static-1.3141",
  "reporting-enablement": "static-1.22803",
  "chatspot-widget-iframe": "static-1.21130",
  "collaboration-sidebar-common": "static-1.2500",
  "forms-ai-lib": "static-1.4267",
  "codemirror-dlb": "static-1.58583",
  "redux-mock-store": "static-1.8",
  "redux-undo": "static-1.10",
  "seo-tools-lib": "static-1.6397",
  "report-customization-components": "static-1.13071",
  "data-quality-ui-library": "static-1.12897",
  "html-to-image": "static-1.53",
  "reporting-filters": "static-1.257",
  "reporting-insights-lib": "static-1.1645"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.12145",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "client-types": "/client-types/static-1.465",
  "dashboard-client-types": "/dashboard-client-types/static-1.361",
  "data-fetching-client": "/data-fetching-client/static-1.9640",
  "foundations-components": "/foundations-components/static-1.7867",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.892",
  "foundations-theming": "/foundations-theming/static-1.4386",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.81",
  "head-dlb": "/head-dlb/static-1.4938",
  "hs-test-utils": "/hs-test-utils/static-1.7982",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9885",
  "hubspot-dlb": "/hubspot-dlb/static-2.1832",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4049",
  "HubStyleTokens": "/HubStyleTokens/static-2.11433",
  "I18n": "/I18n/static-7.1615",
  "jasmine-runner": "/jasmine-runner/static-1.6435",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.12206",
  "quartz": "/quartz/static-1.6982",
  "react-dlb": "/react-dlb/static-1.78",
  "react-rhumb": "/react-rhumb/static-1-feature-id-1459-enable-web-vitals-adapter.5",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.2827",
  "reporting-testing-lib": "/reporting-testing-lib/static-1-jbartola_hubspot-replace-checked-ts.72",
  "settings-ui-lib": "/settings-ui-lib/static-1.12489",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7074",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11118",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9512",
  "unified-auth": "/unified-auth/static-1.451",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.732",
  "usage-tracker": "/usage-tracker/static-1.7314",
  "usage-tracker-core": "/usage-tracker-core/static-1.7164",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8054",
  "hub-http": "/hub-http/static-1.6190",
  "integrations-lib": "/integrations-lib/static-1.16014",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.19601",
  "property-management-iframe": "/property-management-iframe/static-1.13036",
  "quartz-config": "/quartz-config/static-1.760",
  "quartz-core": "/quartz-core/static-1.6201",
  "quartz-routing": "/quartz-routing/static-1.412",
  "quick-fetch": "/quick-fetch/static-1.3889",
  "react": "/react/static-7.185",
  "rpc-client-utils": "/rpc-client-utils/static-1.4619",
  "ts-schema": "/ts-schema/static-1.4050",
  "ui-universal-auth": "/ui-universal-auth/static-1.8937",
  "UIComponents": "/UIComponents/static-3.8380",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "enviro": "/enviro/static-4.428",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5489",
  "PortalIdParser": "/PortalIdParser/static-2.388",
  "raven": "/raven/static-3.5829",
  "raven-hubspot": "/raven-hubspot/static-1.6136",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.77",
  "metrics-js": "/metrics-js/static-1.9542",
  "react-redux": "/react-redux/static-7.70",
  "redux": "/redux/static-4.16",
  "styled-components": "/styled-components/static-2.88",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3376",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3259",
  "quartz-webpack": "/quartz-webpack/static-1.3206",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.60",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4136",
  "floating-ui": "/floating-ui/static-1.55",
  "foundations-assets": "/foundations-assets/static-1.4830",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2102",
  "framer-motion": "/framer-motion/static-1.71",
  "hs-story-utils": "/hs-story-utils/static-1.9397",
  "react-aria": "/react-aria/static-1.65",
  "react-create-root-preference": "/react-create-root-preference/static-1.13",
  "react-select-plus": "/react-select-plus/static-1.104",
  "react-utils": "/react-utils/static-2.5316",
  "react-virtualized": "/react-virtualized/static-2.98",
  "StyleGuideUI": "/StyleGuideUI/static-3.486",
  "tanstack-table": "/tanstack-table/static-1.54",
  "trellis-assets": "/trellis-assets/static-1.1766",
  "ui-fonts": "/ui-fonts/static-1.695",
  "ui-images": "/ui-images/static-2.1143",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2869",
  "foundations-theming-base": "/foundations-theming-base/static-1.3371",
  "stylex": "/stylex/static-1.32",
  "HeadJS": "/HeadJS/static-2.745",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3093",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.151",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.220",
  "moment-timezone": "/moment-timezone/static-5.82",
  "jasmine": "/jasmine/static-4.4295",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8857",
  "ai-rendering-library": "/ai-rendering-library/static-1.10011",
  "chirp-fetch": "/chirp-fetch/static-1.1855",
  "connections-embed-lib": "/connections-embed-lib/static-1.930",
  "copilot-toolkit": "/copilot-toolkit/static-1.11051",
  "feedback-loader": "/feedback-loader/static-1.29237",
  "laboratory-lib": "/laboratory-lib/static-3.7128",
  "marketplace-embed": "/marketplace-embed/static-1.21986",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.9497",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.19557",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.13772",
  "sanitize-text": "/sanitize-text/static-1.8111",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8669",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5728",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5000",
  "wootric-nps": "/wootric-nps/static-1.6951",
  "quartz-head": "/quartz-head/static-1.647",
  "web-vitals": "/web-vitals/static-1.4",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4617",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4123",
  "highcharts": "/highcharts/static-8.103",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2485",
  "reporting-data": "/reporting-data/static-1-jbartola_hubspot-replace-checked-ts.72",
  "cssUtils": "/cssUtils/static-1.782",
  "flux-actions": "/flux-actions/static-1.331",
  "HubStyle": "/HubStyle/static-2.11741",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "react-colorpicker": "/react-colorpicker/static-2.10178",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10339",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7304",
  "icons": "/icons/static-2.644",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.18134",
  "storybook-react": "/storybook-react/static-1.32",
  "trellis-story-utils": "/trellis-story-utils/static-1.4484",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5350",
  "quartz-i18n": "/quartz-i18n/static-1.657",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.141",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.258",
  "fsm": "/fsm/static-1.3700",
  "customer-data-objects": "/customer-data-objects/static-1.7631",
  "property-translator": "/property-translator/static-1.5370",
  "hs-locale-management": "/hs-locale-management/static-1.58",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7897",
  "hs-promise-utils": "/hs-promise-utils/static-1.5563",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4845",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13429",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5568",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7751",
  "reselect": "/reselect/static-2.16",
  "sanitize": "/sanitize/static-1.4444",
  "superstore": "/superstore/static-1.4734",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10123",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.7832",
  "hub-http-janus": "/hub-http-janus/static-1.828",
  "hubspotter-http": "/hubspotter-http/static-1.4624",
  "immutable-less": "/immutable-less/static-1.4620",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.17008",
  "nav-meta": "/nav-meta/static-1.29569",
  "react-window": "/react-window/static-1.13",
  "self-service-api": "/self-service-api/static-1.10214",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17937",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3816",
  "property-management-common": "/property-management-common/static-1.5324",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9026",
  "dispatcher": "/dispatcher/static-1.135",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.519",
  "module-federation": "/module-federation/static-1.22",
  "quartz-auth": "/quartz-auth/static-1.657",
  "quartz-test": "/quartz-test/static-1.657",
  "quartz-tracking": "/quartz-tracking/static-1.361",
  "history": "/history/static-4.47",
  "react-router-dom": "/react-router-dom/static-5.26",
  "csstype": "/csstype/static-1.50",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.29",
  "bender-build-tools": "/bender-build-tools/static-1.3160",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3563",
  "persist-promise": "/persist-promise/static-1.3668",
  "reference-resolvers": "/reference-resolvers/static-1.8137",
  "transmute": "/transmute/static-2.85",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.21139",
  "ContentUtils": "/ContentUtils/static-1.68266",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12994",
  "sassPrefix": "/sassPrefix/static-1.155",
  "avatar-components": "/avatar-components/static-1.2466",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.39641",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13128",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.14240",
  "ExportDialog": "/ExportDialog/static-6.10362",
  "highlight.js": "/highlight.js/static-1.78",
  "markdown-it": "/markdown-it/static-1.6",
  "reporting-action-components": "/reporting-action-components/static-1.41211",
  "reporting-snowflake": "/reporting-snowflake/static-1-jbartola_hubspot-replace-checked-ts.72",
  "reporting-ui-components": "/reporting-ui-components/static-2-jbartola_hubspot-replace-checked-ts.72",
  "reporting-visualizations": "/reporting-visualizations/static-1-jbartola_hubspot-replace-checked-ts.72",
  "ui-addon-teams": "/ui-addon-teams/static-1.21501",
  "magpie-lib": "/magpie-lib/static-1.5536",
  "navigation-components": "/navigation-components/static-1.17932",
  "magpie-types": "/magpie-types/static-1.4996",
  "simple-logging-lib": "/simple-logging-lib/static-1.3018",
  "ai-studio-lib": "/ai-studio-lib/static-1.11515",
  "app-governance-lib": "/app-governance-lib/static-1.1444",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10478",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.7965",
  "ui-product-approvals": "/ui-product-approvals/static-1.28046",
  "ui-tool-access": "/ui-tool-access/static-1.10119",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.8718",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5731",
  "usage-tracker-public": "/usage-tracker-public/static-1.7125",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.59",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.3897",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.304",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2982",
  "final-form": "/final-form/static-1.69",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "simple-data-table": "/simple-data-table/static-1.2686",
  "merchandise-lib": "/merchandise-lib/static-1.262",
  "atom": "/atom/static-1.5040",
  "purchase-motions-components": "/purchase-motions-components/static-1.5823",
  "salesImages": "/salesImages/static-1.524",
  "batch-promise": "/batch-promise/static-1.1511",
  "crm-component-utils": "/crm-component-utils/static-1.38998",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.5847",
  "customer-data-properties": "/customer-data-properties/static-1.51432",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6850",
  "property-value-citations": "/property-value-citations/static-1.2046",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8064",
  "navigation-messaging": "/navigation-messaging/static-1.7259",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9883",
  "growth-payments-core": "/growth-payments-core/static-1.25281",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13587",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7217",
  "crm-message-bus": "/crm-message-bus/static-1.42905",
  "reporting-plugins": "/reporting-plugins/static-1.10268",
  "reporting-reports": "/reporting-reports/static-1-jbartola_hubspot-replace-checked-ts.72",
  "cms-field-types": "/cms-field-types/static-1.4781",
  "content-icons-ui": "/content-icons-ui/static-1.2216",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9794",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.22076",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4687",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3982",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6755",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.947",
  "onboarding-tours": "/onboarding-tours/static-1.16536",
  "academy-common-lib": "/academy-common-lib/static-1.13700",
  "content-assistance-lib": "/content-assistance-lib/static-1.7700",
  "dashboard-lib": "/dashboard-lib/static-1.81388",
  "file-manager-components": "/file-manager-components/static-1.23527",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18414",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18154",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.18146",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.19773",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8670",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4737",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10979",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9018",
  "user-context": "/user-context/static-1.5071",
  "idb-keyval": "/idb-keyval/static-1.43",
  "reactive-lib": "/reactive-lib/static-1.690",
  "nest": "/nest/static-1.194",
  "codemirror": "/codemirror/static-5.94",
  "react-codemirror": "/react-codemirror/static-1.10593",
  "framework-listing-lib": "/framework-listing-lib/static-2.28600",
  "fuzzy": "/fuzzy/static-1.8",
  "user-configuration-lib": "/user-configuration-lib/static-1.30644",
  "apps-service-types": "/apps-service-types/static-1.3846",
  "oauth-service-types": "/oauth-service-types/static-1.4219",
  "onboarding-scopes": "/onboarding-scopes/static-1.6431",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4750",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7645",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.14883",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3581",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9156",
  "redux-thunk": "/redux-thunk/static-2.43",
  "purchase-motions-api": "/purchase-motions-api/static-1.5826",
  "signup-constants": "/signup-constants/static-1.18784",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8009",
  "trials-service-types": "/trials-service-types/static-1.3872",
  "card-properties-lib": "/card-properties-lib/static-1.44081",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.37013",
  "crm-actions": "/crm-actions/static-1.6290",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.43490",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9212",
  "customer-data-tracking": "/customer-data-tracking/static-1.6854",
  "hs-resources": "/hs-resources/static-1.120",
  "pulse": "/pulse/static-1.533",
  "calling-global-api": "/calling-global-api/static-1.64406",
  "calling-internal-common": "/calling-internal-common/static-1.31271",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65788",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58082",
  "commerce-products-lib": "/commerce-products-lib/static-1.9431",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3769",
  "crm-links": "/crm-links/static-1.6253",
  "external-options-client-types": "/external-options-client-types/static-1.4130",
  "google-libphonenumber": "/google-libphonenumber/static-1.37",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4196",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.601",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3664",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48629",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3938",
  "smart-property-lib": "/smart-property-lib/static-1.6757",
  "tiered-pricing": "/tiered-pricing/static-1.1132",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10959",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4115",
  "ui-addon-opt": "/ui-addon-opt/static-4.8338",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.8997",
  "react-dnd-compat": "/react-dnd-compat/static-1.4589",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "growth-data-modal": "/growth-data-modal/static-1.5376",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3035",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1829",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.602",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7504",
  "academy-service-client": "/academy-service-client/static-1.3650",
  "croppie": "/croppie/static-2.10",
  "FileManagerCore": "/FileManagerCore/static-1.39026",
  "FileManagerLib": "/FileManagerLib/static-1.39167",
  "video-embed": "/video-embed/static-1.35659",
  "zustand": "/zustand/static-1.74",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28460",
  "redux-actions": "/redux-actions/static-3.7",
  "video-components-external": "/video-components-external/static-1.11167",
  "video-data-lib": "/video-data-lib/static-1.34825",
  "emoji-mart": "/emoji-mart/static-3.4",
  "knowledge-content-types": "/knowledge-content-types/static-1.8483",
  "payment-link-components": "/payment-link-components/static-1.23446",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9856",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.24298",
  "viral-links-lib": "/viral-links-lib/static-1.7025",
  "data-token-picker": "/data-token-picker/static-1.16347",
  "react-flip-move": "/react-flip-move/static-1.69",
  "nested-table": "/nested-table/static-1.193",
  "timezone-utils": "/timezone-utils/static-2.5212",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17532",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "browser-eslint": "/browser-eslint/static-2.57",
  "customer-data-associations": "/customer-data-associations/static-1.7293",
  "customer-data-views-management": "/customer-data-views-management/static-1.25384",
  "framework-data-table": "/framework-data-table/static-2.11840",
  "marketing-platform-lib": "/marketing-platform-lib/static-1.6821",
  "nudge-client-utils": "/nudge-client-utils/static-1.2497",
  "nudge-custom-ui-functions": "/nudge-custom-ui-functions/static-1.975",
  "app-users-service-client": "/app-users-service-client/static-1.5564",
  "app-users-service-types": "/app-users-service-types/static-1.4972",
  "mini-checkout-client": "/mini-checkout-client/static-1.26717",
  "onboarding-utils": "/onboarding-utils/static-1.5322",
  "permissions-shared-i18n-strings-fe": "/permissions-shared-i18n-strings-fe/static-1.2044",
  "ui-coaching-tips-shared-config": "/ui-coaching-tips-shared-config/static-1.28445",
  "edison-service-client-types": "/edison-service-client-types/static-1.355",
  "crm_data": "/crm_data/static-4.91859",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.45921",
  "enrichment-properties-lib": "/enrichment-properties-lib/static-1.15875",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.18974",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.18439",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.10284",
  "crm-fe-perf": "/crm-fe-perf/static-1.22872",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.36",
  "directed-graph": "/directed-graph/static-1.904",
  "event-emitter": "/event-emitter/static-1.917",
  "fast-json-patch": "/fast-json-patch/static-1.62",
  "calling-error-reporting": "/calling-error-reporting/static-1.31277",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11007",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6512",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.852",
  "commerce-permissions": "/commerce-permissions/static-1.735",
  "products-iframe-lib": "/products-iframe-lib/static-1.7843",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10267",
  "data-agent-kit": "/data-agent-kit/static-1.141",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9968",
  "policy-lib": "/policy-lib/static-1.6744",
  "react-tinymce": "/react-tinymce/static-1.55147",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10031",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.54273",
  "tinymce-plugins": "/tinymce-plugins/static-1.57387",
  "tinymce-themes": "/tinymce-themes/static-1.56243",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.504",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.1905",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.1857",
  "user-context-client": "/user-context-client/static-1.4580",
  "audio-components": "/audio-components/static-1.5865",
  "cropperjs": "/cropperjs/static-1.10",
  "FileManagerImages": "/FileManagerImages/static-1.36678",
  "urlinator": "/urlinator/static-1.4501",
  "video-components": "/video-components/static-1.13170",
  "outpost": "/outpost/static-1.4155",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6550",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12152",
  "content-media-compositions": "/content-media-compositions/static-2.16159",
  "media-bridge-lib": "/media-bridge-lib/static-1.18870",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6032",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5051",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3608",
  "draft-convert": "/draft-convert/static-2.72",
  "draft-extend": "/draft-extend/static-3.74",
  "draft-js": "/draft-js/static-5.77",
  "draft-plugins": "/draft-plugins/static-2.21616",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3811",
  "ts-utils-lib": "/ts-utils-lib/static-1.142",
  "crm-export-dialog": "/crm-export-dialog/static-1.6267",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6409",
  "react-beautiful-dnd": "/react-beautiful-dnd/static-1.13",
  "deal-intel-decorators": "/deal-intel-decorators/static-1.1878",
  "tanstack-virtual": "/tanstack-virtual/static-1.29",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.2254",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.2573",
  "whisper-core-api": "/whisper-core-api/static-1.6529",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.14724",
  "emoji-regex": "/emoji-regex/static-1.7",
  "touchless-buying-components": "/touchless-buying-components/static-1.5424",
  "settings-content-modals": "/settings-content-modals/static-1.45986",
  "crm_universal": "/crm_universal/static-1.21948",
  "customer-data-email": "/customer-data-email/static-1.17975",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.37073",
  "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.39436",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.11925",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.54615",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.21382",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.17715",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.71894",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5307",
  "utility-belt": "/utility-belt/static-1.2505",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.22661",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.7445",
  "customer-data-rte": "/customer-data-rte/static-1.32907",
  "cv-backend-services": "/cv-backend-services/static-1.1552",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.5658",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5078",
  "qrcode-generator": "/qrcode-generator/static-1.68",
  "quotes-client-types": "/quotes-client-types/static-1.37984",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35629",
  "sales-views-client-types": "/sales-views-client-types/static-1.4233",
  "hub-http-contrib": "/hub-http-contrib/static-1.3007",
  "interframe": "/interframe/static-3.4728",
  "tinymce-data": "/tinymce-data/static-1.40358",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5179",
  "layout-dnd-components": "/layout-dnd-components/static-1.12381",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11356",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15130",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9035",
  "ably": "/ably/static-2.2",
  "social-insights-client-types": "/social-insights-client-types/static-1.22006",
  "js-cookie": "/js-cookie/static-1.18",
  "deal-intel-utils": "/deal-intel-utils/static-1.1882",
  "checkout-sdk": "/checkout-sdk/static-3.23560",
  "checkout-service-types": "/checkout-service-types/static-1.3799",
  "company-details-components": "/company-details-components/static-1.6165",
  "payment-method-components": "/payment-method-components/static-1.6881",
  "pricing-pages-ui-components": "/pricing-pages-ui-components/static-1.13782",
  "quote-checkout-service-types": "/quote-checkout-service-types/static-1.3443",
  "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.3493",
  "access-control-lib": "/access-control-lib/static-1.10405",
  "EmailComponents": "/EmailComponents/static-1.54685",
  "EmailData": "/EmailData/static-1.53362",
  "redux-less": "/redux-less/static-2.9451",
  "sequences-lib": "/sequences-lib/static-1.7983",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10315",
  "products-ui-components": "/products-ui-components/static-1.39950",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.7011",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.54631",
  "commerce-products-api": "/commerce-products-api/static-1.2237",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.56689",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.102572",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.80615",
  "stripe-connect-js": "/stripe-connect-js/static-1.68",
  "draft-content-plugins": "/draft-content-plugins/static-1.28175",
  "ContentData": "/ContentData/static-1.68341",
  "layout-data-lib": "/layout-data-lib/static-1.9681",
  "hub-http-rxjs": "/hub-http-rxjs/static-1.794",
  "normalizr": "/normalizr/static-3.9",
  "ramda": "/ramda/static-1.7",
  "company-details-service-types": "/company-details-service-types/static-1.3903",
  "billing-payments-client-types": "/billing-payments-client-types/static-1.3958",
  "react-performance-metrics-lib": "/react-performance-metrics-lib/static-1.528",
  "account-and-billing-fintech-outages": "/account-and-billing-fintech-outages/static-3.18537",
  "pricing-pages-api": "/pricing-pages-api/static-1.13647",
  "ContentComponents": "/ContentComponents/static-2.71222",
  "marketing-contacts-lib": "/marketing-contacts-lib/static-1.9888",
  "marketing-email-service-types": "/marketing-email-service-types/static-1.1897",
  "messaging-editing-lib": "/messaging-editing-lib/static-1.46174",
  "messaging-usage-based-billing-components-lib": "/messaging-usage-based-billing-components-lib/static-1.1036",
  "automation-ui-source-apps": "/automation-ui-source-apps/static-1.18782",
  "automation-ui-types": "/automation-ui-types/static-1.19700",
  "messaging-types-lib": "/messaging-types-lib/static-1.45911",
  "onboarding-settings-client": "/onboarding-settings-client/static-1.4472",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.7840",
  "commerce-tax-lib": "/commerce-tax-lib/static-1.493",
  "price-books-api": "/price-books-api/static-1.537",
  "price-books-components": "/price-books-components/static-1.595",
  "property-description-translator": "/property-description-translator/static-1.3815",
  "ramp-editor": "/ramp-editor/static-1.66",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3596",
  "totals-ui-components": "/totals-ui-components/static-1.23505",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9193",
  "advanced-menus-core": "/advanced-menus-core/static-1.15079",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12026",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33958",
  "segments-query-core": "/segments-query-core/static-1.1387",
  "demographics-service-types": "/demographics-service-types/static-1.1621",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.3153",
  "automation-ui-ubb": "/automation-ui-ubb/static-1.5616",
  "blueimp-md5": "/blueimp-md5/static-1.8",
  "content-embed-lib": "/content-embed-lib/static-1.7308",
  "data-token-views": "/data-token-views/static-1.16328",
  "forms-utils-lib": "/forms-utils-lib/static-1.12516",
  "payments-embed-points-lib": "/payments-embed-points-lib/static-1.12961",
  "simple-menus-core": "/simple-menus-core/static-1.15078",
  "simple-menus-lib": "/simple-menus-lib/static-1.16595",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4224",
  "videoconference-integration-components": "/videoconference-integration-components/static-1.6771",
  "marketing-contacts-client": "/marketing-contacts-client/static-1.7487",
  "automation-applications-service-types": "/automation-applications-service-types/static-1.3470",
  "automation-platform-service-types": "/automation-platform-service-types/static-1.2572",
  "ContentEditorUI": "/ContentEditorUI/static-2.77024",
  "short-messages-app-service-client": "/short-messages-app-service-client/static-1.3949",
  "web-interactives-components": "/web-interactives-components/static-1.13702",
  "web-interactives-data": "/web-interactives-data/static-1.13703",
  "messaging-shared-utils-lib": "/messaging-shared-utils-lib/static-1.485",
  "messaging-user-info-utils-lib": "/messaging-user-info-utils-lib/static-1.655",
  "email-portal-health-service-types": "/email-portal-health-service-types/static-1.945",
  "line-items-api": "/line-items-api/static-1.638",
  "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3790",
  "FireAlarmUi": "/FireAlarmUi/static-1.4486",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4141",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "automation-ui-core": "/automation-ui-core/static-2.21636",
  "automation-ui-usage-tracking": "/automation-ui-usage-tracking/static-1.21099",
  "data-studio-ubb": "/data-studio-ubb/static-1.2631",
  "backbone": "/backbone/static-1.6",
  "campaigns-lib": "/campaigns-lib/static-1.26946",
  "collaboration-sidebar": "/collaboration-sidebar/static-1.57703",
  "content-management-data-lib": "/content-management-data-lib/static-1.5343",
  "copilot-plugins": "/copilot-plugins/static-1.11024",
  "cta-picker": "/cta-picker/static-1.36313",
  "customer-agent-discovery-components-lib": "/customer-agent-discovery-components-lib/static-1.2998",
  "editor-components": "/editor-components/static-1.13185",
  "editor-iframe-lib": "/editor-iframe-lib/static-1.8355",
  "error-messaging-js": "/error-messaging-js/static-1.5160",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.85751",
  "pictos": "/pictos/static-7.183",
  "react-transition-group": "/react-transition-group/static-2.64",
  "redux-request-state": "/redux-request-state/static-1.10614",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1715",
  "smart-content-core": "/smart-content-core/static-1.42348",
  "smart-content-lib": "/smart-content-lib/static-1.43001",
  "social-composer-lib": "/social-composer-lib/static-1.58966",
  "structured-content-lib": "/structured-content-lib/static-1.25104",
  "theme-previewer-lib": "/theme-previewer-lib/static-1.53162",
  "tinymce-copilot": "/tinymce-copilot/static-1.16341",
  "xray-recommendation-lib": "/xray-recommendation-lib/static-1.7854",
  "automation-ui-routing": "/automation-ui-routing/static-1.21057",
  "sql-reporting-client-types": "/sql-reporting-client-types/static-1.5608",
  "jquery": "/jquery/static-3.6",
  "attribution-lib": "/attribution-lib/static-1.42122",
  "campaigns-utils-lib": "/campaigns-utils-lib/static-1.3141",
  "reporting-enablement": "/reporting-enablement/static-1.22803",
  "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.21130",
  "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.2500",
  "forms-ai-lib": "/forms-ai-lib/static-1.4267",
  "codemirror-dlb": "/codemirror-dlb/static-1.58583",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-undo": "/redux-undo/static-1.10",
  "seo-tools-lib": "/seo-tools-lib/static-1.6397",
  "report-customization-components": "/report-customization-components/static-1.13071",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.12897",
  "html-to-image": "/html-to-image/static-1.53",
  "reporting-filters": "/reporting-filters/static-1.257",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.1645"
}
};
